import get from 'lodash/get'
import { Audience, AudienceSettingsSchemaItem } from '../../../../../types/GCB2'
import { AUDEINCE_ADDITIONAL_SETTINGS, CHANGE_ACTIVATION_TYPES } from '../../../../../vars/GCB2'

export const MAILING_ADDITIONAL_SETTINGS_TITLE = 'Дополнительные настройки рассылки'

function flattenSchemaItems(raw: any): AudienceSettingsSchemaItem[] {
    if (!Array.isArray(raw)) {
        return []
    }
    if (raw.length && Array.isArray(raw[0]) && !(raw[0] as any).type) {
        return raw.flat()
    }
    return raw
}

export function buildMailingAdditionalSettingsGroups(
    audience: Audience | undefined,
    mode: string,
): AudienceSettingsSchemaItem[][] {
    const keys = audience?.settings?.additional_params_list
    if (!Array.isArray(keys) || !keys.length) {
        return []
    }

    const groups: AudienceSettingsSchemaItem[][] = []
    Object.keys(AUDEINCE_ADDITIONAL_SETTINGS)
        .filter((key) => keys.includes(key))
        .filter((key) => !get(AUDEINCE_ADDITIONAL_SETTINGS, `${key}.hidden`))
        .forEach((key) => {
            const raw =
                get(audience?.settings.additional_params_schema_override, key) ??
                get(AUDEINCE_ADDITIONAL_SETTINGS, `${key}.schema`)
            const items = flattenSchemaItems(raw)
            if (!items.length) {
                return
            }
            const disabled = mode === CHANGE_ACTIVATION_TYPES.edit
                ? !get(AUDEINCE_ADDITIONAL_SETTINGS, `${key}.canEdit`)
                : false
            groups.push(items.map((item) => (disabled ? { ...item, disabled: true } : item)))
        })

    return groups
}
